<template>
  <div
    v-if="!iframeLink"
    class="d-flex justify-center align-center"
    :style="`height: ${contentHeight}px;`"
  >
    <v-progress-circular indeterminate color="primary" />
  </div>
  <iframe
    v-else
    ref="formStepIframe"
    width="100%"
    :height="`${contentHeight}px`"
    :src="iframeLink"
    @load="onIframeLoad"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { Capacitor } from '@capacitor/core';

export default {
  name: 'IframeStep',
  props: {
    storePath: {
      type: String,
      required: true
    },
    iframeLink: {
      type: String,
      default: null
    },
    dialogTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      windowInnerHeight: window.innerHeight
    };
  },
  computed: {
    ...mapGetters({
      windowSize: 'general/windowSize'
    }),
    dialogWidth() {
      return this.$store.getters[`${this.storePath}/dialogWidth`];
    },
    dialogHeaderType() {
      return this.$store.getters[`${this.storePath}/dialogHeaderType`];
    },
    dialogContentJustify() {
      return this.$store.getters[`${this.storePath}/dialogContentJustify`];
    },
    dialogContentDisplayClasses() {
      return this.$store.getters[`${this.storePath}/dialogContentDisplayClasses`];
    },
    isMobile() {
      return this.windowSize.x < 550;
    },
    contentHeight() {
      return this.isMobile ? this.windowInnerHeight : 550;
    }
  },
  watch: {
    windowSize: {
      deep: true,
      handler() {
        this.windowInnerHeight = window.innerHeight;
        this.setSizedStoreVariables();
      }
    },
    iframeLink(newVal) {
      if (!newVal || !Capacitor.isNativePlatform()) {
        return;
      }

      // On iOS WKWebView the iframe `load` event is unreliable for cross-origin
      // content. Attach a native listener after the element is rendered and add
      // a timeout fallback in case the event never fires.
      this.$nextTick(() => {
        const el = this.$refs.formStepIframe;
        if (el) {
          el.addEventListener('load', this.onIframeLoad, { once: true });
        }
        this._iframeFallbackTimer = setTimeout(() => {
          this.onIframeLoad();
        }, 2000);
      });
    }
  },
  mounted() {
    this.setDialogTitle(this.dialogTitle);
    this.setSizedStoreVariables();
  },
  methods: {
    setDialogHeaderType(dialogHeaderType) {
      this.$store.dispatch(`${this.storePath}/setDialogHeaderType`, dialogHeaderType);
    },
    setDialogTitle(dialogTitle) {
      this.$store.dispatch(`${this.storePath}/setDialogTitle`, dialogTitle);
    },
    setDialogContentJustify(dialogContentJustify) {
      this.$store.dispatch(`${this.storePath}/setDialogContentJustify`, dialogContentJustify);
    },
    setDialogContentDisplayClasses(dialogContentDisplayClasses) {
      this.$store.dispatch(
        `${this.storePath}/setDialogContentDisplayClasses`,
        dialogContentDisplayClasses
      );
    },
    setSizedStoreVariables() {
      this.setDialogHeaderType(this.windowSize.x < this.dialogWidth ? 'navigation' : 'none');
      this.setDialogContentJustify(this.windowSize.x < this.dialogWidth ? 'center' : 'start');

      const dialogHeaderElement = document.querySelector('.dialog-header');

      this.setDialogContentDisplayClasses(
        dialogHeaderElement &&
          this.windowSize.y - dialogHeaderElement.clientHeight < this.contentHeight
          ? 'd-block'
          : 'd-flex'
      );
    },
    onIframeLoad() {
      clearTimeout(this._iframeFallbackTimer);

      this.$log('IframeStep', `isNativePlatform: ${Capacitor.isNativePlatform()}`, 'D');
      this.$log(
        'IframeStep',
        `dialogMainContentHeight: ${document.querySelector('.dialog-main-content').clientHeight}`,
        'D'
      );

      if (Capacitor.isNativePlatform()) {
        this.contentHeight = document.querySelector('.dialog-main-content').clientHeight;
      }
    }
  }
};
</script>
